import {get_investor_details} from '../../actions';

export const update_investor_details = data => dispatch => {
	var url = global.config.server_path + 'investment/update_investor_details';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(data)})
	.then(resp => resp.json())
	.then(resp => global.validate_response(resp))
	.then(resp => dispatch(get_investor_details()))
	.catch(err => Promise.reject(err))
};